import { Reveal, Overline } from "../Reveal";
import { FAQS } from "../../data/content";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";

export const FAQ = () => (
  <section data-testid="faq-section" className="bg-white py-24 lg:py-32">
    <div className="mx-auto max-w-7xl px-5 lg:px-8 grid gap-14 lg:grid-cols-12">
      <div className="lg:col-span-4">
        <Overline>Good to Know</Overline>
        <Reveal>
          <h2 className="mt-6 font-display text-3xl md:text-4xl lg:text-5xl tracking-tight text-sml-charcoal">
            Frequently Asked Questions
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-6 text-sml-charcoal/60 leading-relaxed">
            Everything you need to know about working with SML Property Solutions.
          </p>
        </Reveal>
      </div>
      <div className="lg:col-span-8">
        <Accordion type="single" collapsible className="w-full" defaultValue="item-0">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-item-${i}`} className="border-sml-border">
              <AccordionTrigger className="text-left font-display text-lg md:text-xl text-sml-charcoal hover:text-sml-forest hover:no-underline py-6">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-sml-charcoal/70 text-base leading-relaxed pb-6">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  </section>
);
